import React from "react";
//components
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import DesktopDateRangePicker from "@mui/lab/DesktopDateRangePicker";

//utils
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Box } from "@mui/material";
import moment from "moment";
import { styled } from "@mui/material/styles";

interface IDateRangePickerUI {
  input: any;
  label: JSX.Element | JSX.Element[];
  labelTwo?: JSX.Element | JSX.Element[];
  meta: any;
  changeForm: any;
  valueForm: any;
}

export default function DateRangePicker(props: IDateRangePickerUI) {
  const {
    input,
    label,
    labelTwo,
    meta,
    changeForm,
    valueForm = [null, null],
  } = props;
  const { touched, error } = meta;

  const handleChange = (value: any) => {
    changeForm(input.name, value);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Stack spacing={3} sx={{ width: "100%" }}>
        <DesktopDateRangePicker
          /*  onError={touched && error} */
          startText={label}
          endText={labelTwo}
          value={valueForm}
          onChange={(newValue: any) => {
            handleChange(newValue);
          }}
          renderInput={(startProps: any, endProps: any) => {
            let start = startProps;
            if (start.inputProps.value && start.inputProps.value !== "") {
              start.inputProps.value = moment(start.inputProps.value).format(
                "DD/MM/YYYY"
              );
            }
            let end = endProps;
            if (end.inputProps.value && end.inputProps.value !== "") {
              end.inputProps.value = moment(end.inputProps.value).format(
                "DD/MM/YYYY"
              );
            }
            return (
              <React.Fragment>
                <CssTextField
                  variant="filled"
                  error={touched && error}
                  {...start}
                  sx={{
                    width: "100%",
                    color: "#2d32aa",
                    backgroundColor: "#ffffff",
                    border: "none",
                  }}
                />
                <Box sx={{ mx: 1 }} />
                <CssTextField
                  variant="filled"
                  error={touched && error}
                  {...end}
                  sx={{
                    width: "100%",
                    color: "#2d32aa",
                    backgroundColor: "#ffffff",
                    border: "none",
                  }}
                />
              </React.Fragment>
            );
          }}
        />
      </Stack>
    </LocalizationProvider>
  );
}

const CssTextField = styled(TextField)({
  "& .MuiFilledInput-root": {
    height: "2rem ",
    fontSize: "12px",
    "& fieldset": {
      height: "2rem",
      top: "-8px",
    },
    "&:hover fieldset": {},
    "&.Mui-focused fieldset": {},
  },
  "& .MuiFilledInput-input": {
    height: "2rem ",
    fontSize: "12px",
    paddingTop: "10px",
  },
  "& label.Mui-focused": {},
  "& .MuiInput-underline:after": {},
  "& .MuiInputLabel-root": {
    height: "2rem",
    fontSize: "10px",
    top: "-8px",
  },
});
